// Central data-testid registry for Good Eyes landing.
export const TID = {
  nav: {
    root: "site-nav",
    logo: "site-nav-logo",
    linkRange: "nav-link-range",
    linkStrengths: "nav-link-strengths",
    linkStory: "nav-link-story",
    linkStockists: "nav-link-stockists",
    cta: "nav-cta-shop",
    mobileToggle: "nav-mobile-toggle",
  },
  hero: {
    root: "hero-section",
    headline: "hero-headline",
    tagline: "hero-tagline",
    ctaPrimary: "hero-cta-primary",
    ctaSecondary: "hero-cta-secondary",
    image: "hero-image",
  },
  strength: {
    root: "strength-section",
    swatch: (s) => `strength-swatch-${s.replace(".", "-")}`,
  },
  focus: {
    root: "focus-points-section",
    frame: "focus-frame-image",
    callout: (k) => `focus-callout-${k}`,
  },
  nz: {
    root: "nz-story-section",
    cta: "nz-story-cta",
  },
  gallery: {
    root: "product-gallery-section",
    card: (name) => `product-card-${name.toLowerCase()}`,
    filterAll: "gallery-filter-all",
  },
  retail: {
    root: "retail-stand-section",
    cta: "retail-stockist-cta",
  },
  footer: {
    root: "site-footer",
    newsletterInput: "footer-newsletter-input",
    newsletterSubmit: "footer-newsletter-submit",
    linkInstagram: "footer-link-instagram",
    linkContact: "footer-link-contact",
    backToTop: "footer-back-to-top",
  },
};
